import locationApi from "../../api/location";
import testExpirationHub from "../../api/hubs/testExpirationHub";
import router from "../../router";
import { formatCountdown } from "../../utils/dateTimeFormatter"


export default {
    state: {
        locationId: null,
        locationName: null,
        timeOffset: 0,
        address: null,
        city: null,
        state: null,        
        zip: null,
        csList: []
    },
    mutations: {
        setLocation(state, location) {
            state.locationId = location.LocationId;
            state.locationName = location.LocationName;
            state.address = location.Address;
            state.city = location.City;
            state.state = location.State;
            state.zip = location.Zip;
            state.timeOffset = Math.round((new Date() - new Date(location.LocationTimeString)) / 60 / 60 / 1000);            
        },
        clearLocation(state) {
            state.locationId = null;
            state.locationName = null;
            state.address = null;
            state.city = null;
            state.state = null;
            state.zip = null;
            state.timeOffset = 0;
        },
        setCsNoList: (state, list) => state.csList = list
    },
    actions: {
        async searchLocation({ commit, dispatch }, data) {
            var location = await locationApi.search(data);
            if (location) {
                commit('setLocation', location);
                await dispatch('initUser');
            } else {
                commit('clearLocation');
            }
        },
        async clearLocation({ commit, dispatch, state }) {
            if(state.locationId){
                await locationApi.forgetLocation();
                await testExpirationHub.stopConnection();
                commit('clearLocation');
                await dispatch('initUser');
            }
        },
        async initCsNoList({ commit }) {
            var list = await locationApi.getCsNoList();
            commit('setCsNoList', list);
        },
        async startTestExpirationMonitoring({ commit }) {
            var handlers = {
                test: (data) => {
                    var expirationDate = (new Date()).addMinutes(2).setSeconds(0);
                    commit('addNoty', {
                        type: "error", func: "testExpirationMessages", params: expirationDate, onclick() {
                            router.push({ name: "TestHistoryDetails", params: { testKey: data.TestKey } });
                        }
                    });
                }
            }
            await testExpirationHub.startConnection(handlers);
        }
    },
    getters: {
        fullLocationAddress: state => [state.address, state.city, state.state, state.zip].join(", "),
        csNoList: state => state.csList.map(function (cs) {
            return { value: cs };
        }),
        localTime: (state, getters) => getters.dateNow.addHours(-state.timeOffset),
        timeLeft: (state, getters) => date => new Date(date) - getters.localTime,
        secondsLeftString: (state, getters) => date => formatCountdown(getters.timeLeft(date))
    }
}